module.exports = __webpack_public_path__ + "static/media/assessment-pre-treatment.2d5aa87a.svg";